import React, { Fragment } from 'react';
import { Text, View } from '@react-pdf/renderer';
import intl from 'react-intl-universal';
import { styles } from './styles';
import localData from 'utils/localData';
import PropTypes from 'prop-types';
import { KEY_LABELS, getValueFromLabel, LABELS } from './constants';
import { USER_DATA } from 'shared/constants/users';
import logger from 'utils/logger';

const log = logger.createLogger('ReportDateAndDoctors');

const propTypes = {
  reportContent: PropTypes.object.isRequired,
};

const ReportDateAndDoctors = ({ reportContent }) => {
  const { content } = reportContent;
  const locale = localData.get(USER_DATA.PREFFERED_LANGUAGE);
  return (
    <Fragment>
      <View style={styles.reportDateAndDoctors}>
        <View style={styles.reportDate}>
          <Text>
            {intl.get(KEY_LABELS[LABELS.REPORT_DATE])}{' '}
            {new Date(
              getValueFromLabel(content, KEY_LABELS[LABELS.REPORT_DATE])
            ).toLocaleDateString(locale, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </Text>
        </View>
        <View style={styles.reportDoctors}>
          <Text>
            {intl.get(KEY_LABELS[LABELS.SIGNATURE])}:{' '}
            {getValueFromLabel(content, KEY_LABELS[LABELS.SIGNATURE])}
          </Text>
        </View>
      </View>
    </Fragment>
  );
};

ReportDateAndDoctors.propTypes = propTypes;

export default ReportDateAndDoctors;
